<template>
  <div login class="text-center">
    <form class="form-signin" @submit.prevent="next">
      <h1 class="h3 mb-3 font-weight-normal">가인패드 관리자 로그인</h1>
      <label for="inputEmail" class="sr-only">아이디</label>
      <input v-model="id" type="text" id="inputEmail" class="form-control" placeholder="아이디" required autofocus>
      <label for="inputPassword" class="sr-only">패스워드</label>
      <input v-model="pwd" type="password" id="inputPassword" class="form-control mb-30" placeholder="패스워드" required>
      <button class="btn btn-lg btn-primary btn-block" type="submit">로그인</button>
    </form>
  </div>
</template>

<style lang="less" scoped>
  @import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';

  [login] { height: 100vh;
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #f5f5f5;
  }

  .form-signin { width: 100%; max-width: 330px; padding: 15px; margin: 0 auto;
    .form-control { position: relative; box-sizing: border-box; height: auto; padding: 10px; font-size: 16px;
      &:focus { z-index: 2; }
    }
    input[type="email"] { margin-bottom: -1px; border-bottom-right-radius: 0; border-bottom-left-radius: 0; }
    input[type="password"] { margin-bottom: 10px; border-top-left-radius: 0; border-top-right-radius: 0; }
  }
</style>

<script>
import axios from 'axios';

export default {
  name: 'Login',
  data() {
    return {
      id: '',
      pwd: '',
    };
  },
  methods: {
    next() {
      axios.post('/api/admin/login', { id: this.id, pwd: this.pwd })
        .then(({ data }) => {
          if (data && data.result) {
            window.location.href = '/admin';
          } else {
            alert('아이디와 패스워드를 확인해주세요');
          }
        })
        .catch((e) => {
          alert(e.message);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/Login.vue